'use strict';
/* Kalis - Force judgeme to display (5) instead of "5 reviews" on product recommendations [script] */

(function() {
  (function detectMutations() {
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(function(mutationsList) {
      updateBadges();
    });

    // Start observing the target node for configured mutations
    var targetNode = document.querySelector('.product-recommendations-placeholder');
    var config = { childList: true };
    if (targetNode) {
      observer.observe(targetNode, config);
    }
  })();

  function updateBadges() {
    var badges = document.querySelectorAll('.product-recommendations-placeholder .jdgm-prev-badge__text');
    badges.forEach(function(eBadge) {
      var text = eBadge.textContent;
      text = text.split(' reviews').join('');
      text = text.split(' review').join('');
      text = '(' + text.trim() + ')';
      eBadge.textContent = text;
    });
    console.log('Kalis Force Judgeme - Forced display of "(5)" instead of "5 reviews" by JavaScript in ' + badges.length + ' badges.');
  }
})();
